export enum ERoutes {
	Home,
	Member,
	Speeches,
	Club,
	/**/Outline,
	/**/Committee,
	/**/Association,
	/**/RotaryGlossary,
	Volunteer,
	/**/Ishinomaki,
	/**/Dvd,
	/**/Uminomori,
	/**/Gairojyu,
	/**/Dental,
	/**/Myanmar,
	Makeup,
	/**/OneZone,
	/**/TwoZone,
	/**/ThreeZone,
}

export enum ENavGroups {
	Club,
	Social,
	International,
	MakeUp
}

export interface INav {
	link: string
	label: string,
	exact?: boolean,
	groupId: ENavGroups
}

export interface INavGroup {
	id: ENavGroups
	title: string,
	routes?: IRoute[]
}

export interface IBreadCrumb {
	label: string
	path?: string
}

export interface IPage {
	title: string
	subtitle?: string
	description?: string
	nav?: INav
	parent?: ERoutes
	navGroups?: INavGroup[]
	breadcrumbs: IBreadCrumb[]
}

export interface IRoute extends IPage {
	id: ERoutes
}
